const TildeOk = ({ color, width, height }) => {
  return (
    <svg
      width={width ? width: "15"}
      height={height ? height : "12"}
      viewBox="1 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.1245 5.82469L5.01051 10.0345L13.4302 1.29102"
        stroke={color}
        strokeWidth="2.59067"
      />
    </svg>
  );
};

export default TildeOk;
